import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: { "tags-slider": !_setup.isMobile },
      attrs: { "data-qa": "reviews_tags_slider" },
    },
    [
      _c("div", { class: { "tags-slider__track": !_setup.isMobile } }, [
        _c(
          "div",
          {
            staticClass: "pt-2",
            class: {
              "d-flex": _setup.isMobile,
              "tags-slider__wrapper swiper-wrapper": !_setup.isMobile,
            },
          },
          _vm._l(_setup.tagsList, function (tag) {
            return _c(
              VSheet,
              {
                key: tag.translit,
                staticClass: "pa-4 mr-2 tags-slider__slide",
                attrs: {
                  "data-qa": "reviews_tags_slide",
                  elevation: tag.isActive ? 0 : 2,
                  color: tag.isActive ? "bg-primary" : "bg-gray-0",
                  rounded: "",
                },
                on: {
                  click: function ($event) {
                    return _setup.handleClick(tag)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text-subtitle-2 text--text mb-2 text-no-wrap",
                    attrs: { "data-qa": "reviews_tags_name" },
                  },
                  [_vm._v("\n          " + _vm._s(tag.name) + "\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-center justify-start" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex align-center mr-4" },
                      [
                        _c(
                          VIcon,
                          {
                            attrs: {
                              color: tag.isActive ? "text-info" : "secondary",
                            },
                          },
                          [
                            _vm._v(
                              "\n              ui-icon-heart-active\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-body-2 text--text ml-1",
                            attrs: { "data-qa": "reviews_tags_count_liked" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(tag.countLikedRates) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _c(
                          VIcon,
                          {
                            attrs: {
                              color: tag.isActive
                                ? "text-info"
                                : "button-text-snackbars",
                            },
                          },
                          [
                            _vm._v(
                              "\n              ui-icon-heart-broken\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-body-2 text--text ml-1",
                            attrs: { "data-qa": "reviews_tags_count_disliked" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(tag.countDislikedRates) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      !_setup.isMobile
        ? _c("div", { staticClass: "tags-slider__nav" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "tags-slider__nav-button tags-slider__nav-prev",
        attrs: { "data-qa": "reviews_tags_prev_button" },
      },
      [_c("span", { staticClass: "ui-icon-fz-medium ui-icon-arrow-left" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "tags-slider__nav-button tags-slider__nav-next",
        attrs: { "data-qa": "reviews_tags_next_button" },
      },
      [_c("span", { staticClass: "ui-icon-fz-medium ui-icon-arrow-right" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }